export const Role = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  BRAND_MANAGER: 3,
}
